const SMALL_DEVICE_MAX_SHORT_SIDE = 768;
const MOBILE_LANDING_PATH = "/bookings";

const normalizeOrigin = (url: string) => {
  try {
    const { protocol, origin } = new URL(url);
    return protocol === "http:" || protocol === "https:" ? origin : null;
  } catch {
    return null;
  }
};

// Based on the physical screen and the pointer type, so resizing a desktop browser window never matches.
export const isSmallTouchDevice = (): boolean =>
  window.matchMedia("(pointer: coarse)").matches &&
  Math.min(window.screen.width, window.screen.height) < SMALL_DEVICE_MAX_SHORT_SIDE;

// Runs once at page load. Returns true when the browser is being sent to WebCMS Mobile.
export const redirectToMobileIfNeeded = (): boolean => {
  const mobileUrl = window.REACT_APP_CMS_MOBILE_URL;
  if (!mobileUrl) return false;

  const mobileOrigin = normalizeOrigin(mobileUrl);
  if (!mobileOrigin || mobileOrigin === window.location.origin) return false;

  // Keep OIDC callbacks on the origin that started the sign-in.
  if (window.location.pathname.startsWith("/auth/")) return false;

  if (!isSmallTouchDevice()) return false;

  window.location.replace(`${mobileOrigin}${MOBILE_LANDING_PATH}`);
  return true;
};
